import { createSlice } from "@reduxjs/toolkit"

const emailSlice = createSlice({
    name: "emails",
    initialState: {
        emails: [],
        isFetching: false,
        error: null
    },
    reducers: {
        emailStart: (state) => {
            state.isFetching = true
        },
        emailFailure: (state, action) => {
            state.emails = []
            state.isFetching = false
            state.error = action.payload
        },
        getEmailSuccess: (state, action) => {
            state.emails = action.payload
            state.isFetching = false
            state.error = null
        },
        deleteEmailSuccess: (state, action) => {
            state.emails.splice(
                state.emails.findIndex((item) => item._id === action.payload),
                1
            )
            state.isFetching = false
            state.error = null
        }
    }
})

export const {
    emailStart,
    emailFailure,
    getEmailSuccess,
    deleteEmailSuccess
} = emailSlice.actions

export default emailSlice.reducer